module.exports = __webpack_public_path__ + "static/media/print_white_24dp.1d74027c.svg";